import { Controller } from "@hotwired/stimulus"

/**
 * Input que formatea y valida solo HH:MM.
 * - Solo permite dígitos; inserta ":" automáticamente tras 2 dígitos.
 * - Máximo 5 caracteres (HH:MM).
 * - Al perder foco, normaliza (09:30) y valida.
 */
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.inputTarget.addEventListener("input", (e) => this.onInput(e))
    this.inputTarget.addEventListener("blur", () => this.onBlur())
  }

  onInput(event) {
    let value = event.target.value.replace(/[^\d:]/g, "")
    const colonIndex = value.indexOf(":")
    if (colonIndex >= 0) {
      value = value.slice(0, colonIndex) + ":" + value.slice(colonIndex + 1).replace(/:/g, "")
    } else if (value.length > 2) {
      value = value.slice(0, 2) + ":" + value.slice(2)
    }
    if (value.length > 5) value = value.slice(0, 5)
    event.target.value = value
  }

  onBlur() {
    const value = this.inputTarget.value.trim()
    if (value === "") return

    const match = value.match(/^(\d{1,2}):?(\d{0,2})$/)
    if (!match) {
      this.inputTarget.value = ""
      return
    }

    let hour = parseInt(match[1], 10)
    let minute = parseInt(match[2] || "0", 10)
    hour = Math.min(23, Math.max(0, hour))
    minute = Math.min(59, Math.max(0, minute))

    this.inputTarget.value = String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0")
  }
}
